import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { DocumentTableData } from '@/types/depo20';

interface ApiResponse<T> {
  value: T;
}

export const getDepo20TableList = async (
  oid: number
): Promise<DocumentTableData[]> => {
  try {
    const res = await apiClient.post<ApiResponse<DocumentTableData[]>>(
      Endpoints.Depo20ResultadosSeleccionados,
      {
        oidLiquidacion: oid,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
